import { LlmMode } from '../../app/ApiGen';

export const getLocalLoadManagementMode = (mode: LlmMode | undefined): string => {
  if (mode === 0) {
    return 'Off';
  }
  if (mode === 1) {
    return 'Ethernet Client';
  }
  if (mode === 2) {
    return 'Ethernet Server';
  }
  if (mode === 3) {
    return 'WiFi Client';
  }
  if (mode === 4) {
    return 'WiFi Server';
  }
  return 'Unknown';
};
